export const breakpointValues = {
  xs: 0,
  sm: 576,
  md: 1024,
  lg: 1440,
  xl: 1920
}
